var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#152743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02756 4.67771C8.28731 4.67771 7.68712 4.2654 7.68712 3.75634C7.68712 3.24727 8.28731 2.83496 9.02756 2.83496C9.76781 2.83496 10.3674 3.24727 10.3674 3.75634C10.3674 4.2654 9.76781 4.67771 9.02756 4.67771ZM8.334 14.9625V5.12096H11.322C11.4328 5.12096 11.511 5.20365 11.511 5.31446V10.7752C11.511 10.8855 11.4322 10.98 11.322 10.98H9.675V14.9625C9.675 15.0733 9.59062 15.174 9.47981 15.174H8.54156C8.48661 15.1718 8.43455 15.1488 8.39598 15.1096C8.35741 15.0704 8.33525 15.0174 8.334 14.9625ZM7.83 10.9794H6.69937C6.64471 10.9789 6.59235 10.9573 6.55318 10.9192C6.514 10.881 6.49102 10.8293 6.489 10.7746V5.31446C6.489 5.20365 6.58856 5.12096 6.69881 5.12096H7.83V10.98V10.9794Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.417be38bf4bc19f02a5e817bac6f7507.svg";
export { ForwardRef as ReactComponent };